<template>
    <div class="vdatetime">
        <div class="row">
            <div class="col-md-12">
                <button type="submit" class="btn btn-save mr-2" @click="openobModal"> Create  </button>
              <!-- <button type="button" class="btn wd-button-primary" @click="openobModal">
             Create
            </button> -->
            <!-- <button  class="btn wd-button-secondary"
                            title="Refresh" style="margin-left:5px;"><i class="fa fa-refresh" ></i></button> -->
                            <button type="submit" class="btn btn-save mr-2" style="background-color: white;
color: black;" @click="getScheduleEvents()"> <i class="fa fa-refresh" ></i>  </button>
<b-button v-b-toggle.collapse-1 class="btn mr-2">User Calendars </b-button><b-button v-b-toggle.collapse-2 class="btn mt-2">Blackout Calendars </b-button>
                  <!-- <div id="demo-month" style="height:285px;" class="mt-3"></div> -->


            <b-collapse id="collapse-1" >
                <div class="wd-modal-subheader mt-3 mb-2">
                <h4>User Calendars</h4>
              </div>
            <div class="mt-3" style="height: 300px;overflow-y: auto;">
              <div class="wd-checkbox mb-2" style="margin:0 ;"  >
                          <label>
                            <input class="wd-edited" type="checkbox" v-model="calendarCheckAll" :value="1" checked />
                            <span class="checkbox-decorator" >
                                  <span :class="'check check-cal'" ></span>
                                </span>
                                <b>Select all</b>
                          </label>
                        </div>

              <div class="wd-checkbox" style="margin:0 ;" v-for="(calendar,key) in calendar_options">
                          <label>
                            <input class="wd-edited" type="checkbox" v-model="calendarCheck" :value="calendar.id" checked :style="'color: '+calendar.color"/>
                            <span class="checkbox-decorator" >
                                  <span :class="'check check-cal-'+calendar.id" ></span>
                                </span>
                            {{calendar.name}}
                          </label>
                        </div>
              </div>
              </b-collapse>
              <b-collapse id="collapse-2" >
                <div class="wd-modal-subheader mt-3 mb-2">
                <h4>Blackout Calendars</h4>
              </div>
            <div class="mt-3" style="height: 300px;overflow-y: auto;">
              <div class="wd-checkbox mb-2" style="margin:0 ;"  >
                          <label>
                            <input class="wd-edited" type="checkbox" v-model="calendarCheckAllBlackout" :value="1" checked />
                            <span class="checkbox-decorator" >
                                  <span :class="'check check-cal'" ></span>
                                </span>
                                <b>Select all</b>
                          </label>
                        </div>
                        <div class="wd-checkbox" style="margin:0 ;" v-for="(calendar,key) in calendar_options_blackout">
                          <label>
                            <input class="wd-edited" type="checkbox" v-model="calendarCheckBlackout" :value="calendar.type" checked :style="'color: '+calendar.color"/>
                            <span class="checkbox-decorator" >
                                  <span :class="'check check-blackout-'+calendar.name" ></span>
                                </span>
                            {{calendar.name}}
                          </label>
                        </div>
              </div>
              </b-collapse>
            </div>
            <div class="col-md-12 mt-3">
                <div id="eventcalendar" class="event-calendar" style="height: calc(100vh - 60px);"></div>
                <div id="demo-search-popup" class="md-search-popup">
                    <div>
                        <div id="demo-search-list" class="mbsc-popover-list"></div>
                    </div>
                </div>
            </div>
        </div>
        <!--  Add Schedule MOdal  -->

        <b-modal ref="obModal" title="Create Schedule"  hide-footer>


        <div class="" >

          <div class="">
            <div class="row">
              <div class="col-md-12">
                    <label for="jobInfoName">Job</label>
                    <div class="job-select-div-2">
                    <vue-multiselect onblur="isLoading = false" v-model="selected_job" id="ajax" label="title" :show-labels="false" track-by="title"
                                 placeholder="Search Job" :allow-empty="true"
                                 open-direction="bottom" :options="jobs" :multiple="false"
                                 :internal-search="false" :preselect-first="true" :clear-on-select="true"
                                 :close-on-select="true" :show-no-results="true" :hide-selected="true"
                                 @search-change="jobSearch" >
                                 <template slot="option" slot-scope="props">
                                  <strong>{{ props.option.title }}</strong><br/>
                                  <span>{{ props.option.description }}</span>
                                </template>
                      <span slot="noResult">No Jobs Found!</span>
                      <span slot="noOptions">No Jobs Found!</span>
                    </vue-multiselect></div>
                </div>
                <div class="col-md-12 mt-1">
                    <label for="jobInfoName">Name</label>
                <div class="wd-text-input">

                           <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                     placeholder="Enter name"
                     v-model="schedule.name"
                    ></b-form-input>
                  </div>
                </div>
              <div class="col-md-12">
                <label for="jobInfoName">Calendar</label>
                <div class="wd-v-select">
                    <b-form-select value-field="id"
      text-field="name" v-model="schedule.calendar_id" :options="calendar_options" placeholder="Select calendar"></b-form-select>
                              <!-- <v-select class="wd-edited" v-model="schedule.calendar_id"  label="name"
                              :options="calendar_options"
                              placeholder="Select calendar"
                              :debounce="250"></v-select> -->
                            </div>
                </div>
                <div class="col-md-12">
                <label for="jobInfoName">Date</label>
                <div class="wd-text-input">
                  <date-picker :not-before="new Date()" style="z-index: 10;" v-model="schedule.start_date" id="followUpDeadline" format="YYYY-MM-DD"
                                lang="en"></date-picker>
                            </div>
                </div>
                <div class="col-md-12" >
                  <label for="jobInfoName">Time</label>
                </div>
                <div class="col-md-6" v-if="schedule.all_day == 0">

                <div class="wd-text-input">
                  <b-form-select class="wd-edited" v-model="schedule.start_time" value-field="value"
      text-field="label"  label="label"
                              :options="time_options"
                              placeholder="Select time"
                              :debounce="250"></b-form-select>
                </div>
                </div>
                <div class="col-md-6" v-if="schedule.all_day == 0">

                <div class="wd-text-input">
                  <b-form-select class="wd-edited" v-model="schedule.end_time"  value-field="value"
      text-field="label"
                              :options="time_options"
                              placeholder="Select time"
                              :debounce="250"></b-form-select>
                </div>
                </div>
                <div class="col-md-12" >
                  <div class="date-check mb-2 mt-2"  >
                        <b-form-checkbox
                          id="checkbox-group-1"
                          v-model="schedule.all_day"
                          :value="1"
                          name="flavour-1"
                        >All day</b-form-checkbox>
                      </div>
                </div>
                <div class="col-md-12">
                <label for="jobInfoName">Repeat</label>
                <div class="wd-v-select">
                              <b-form-select class="wd-edited" v-model="schedule.repeat"  label="name"
                              :options="[{text : 'No', value :'No'},{text :'Yes', value : 'Yes'}]"
                              placeholder="Select calendar"
                              :debounce="250"></b-form-select>
                            </div>
                </div>
                <div class="col-md-12" v-if="schedule.repeat == 'Yes'">
                  <div class="date-check" style="margin:0 ;" >
                  <b-form-group >
                        <b-form-checkbox-group
                          id="checkbox-group-1"
                          v-model="schedule.repeat_details"
                          :options="options"
                          name="flavour-1"
                        ></b-form-checkbox-group>
                      </b-form-group>
                      </div>
                </div>
                <div class="col-md-12" v-if="schedule.repeat == 'Yes'">
                  <label for="jobInfoName">Repeat End Date</label>
                </div>
                <div class="col-md-12" v-if="schedule.repeat == 'Yes'">
                <div class="wd-text-input">
                  <date-picker :not-before="new Date()"   style="z-index: 10;" v-model="schedule.repeat_end_date" id="followUpDeadline" format="YYYY-MM-DD"
                                lang="en"></date-picker>
                            </div>
                </div>
                <div class="col-md-12 mt-2 mb-2">
                  <button  type="submit" class="btn btn-save float-right" v-if="isDisabled" :disabled='true' ><i style="margin-left: -4px;margin-right: 6px;" class="fa fa-spinner fa-spin"></i>Submit</button>
            <button v-if="!isDisabled" @click="createSchedule" type="submit" class="btn btn-save float-right" :disabled='isDisabled' >Submit</button>
                </div>
              </div>
            </div>

          </div>
          </b-modal>
          <!--  Add Schedule MOdal End -->
          <!--  Edit Schedule MOdal  -->

            <b-modal ref="obeModal" title="Edit Schedule"  hide-footer>
        <div class="" >

          <div class="wd-modal-body">
            <div class="row">
                <div class="col-md-12">
                    <label for="jobInfoName">Name</label>
                <div class="wd-text-input">
                  <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                     placeholder="Enter name"
                     v-model="editSchedule.name"
                    ></b-form-input>

                  </div>
                </div>
              <div class="col-md-12">
                <label for="jobInfoName">Calendar</label>
                <div class="wd-v-select">
                              <b-form-select value-field="id"
      text-field="name" v-model="editSchedule.calendar_id" :options="calendar_options" placeholder="Select calendar"></b-form-select>
                            </div>
                </div>
                <div class="col-md-12">
                <label for="jobInfoName">Date</label>
                <div class="wd-text-input">
                  <date-picker :not-before="new Date()" style="z-index: 10;" v-model="editSchedule.start_date" id="followUpDeadline" format="YYYY-MM-DD"
                                lang="en"></date-picker>
                            </div>
                </div>
                <div class="col-md-12">
                  <label for="jobInfoName">Time</label>
                </div>
                <div class="col-md-6" v-if="editSchedule.all_day == 0">

                <div class="wd-text-input">

                              <b-form-select class="wd-edited" v-model="editSchedule.start_time" value-field="value"
      text-field="label"  label="label"
                              :options="time_options"
                              placeholder="Select time"
                              :debounce="250"></b-form-select>
                </div>
                </div>
                <div class="col-md-6" v-if="editSchedule.all_day == 0">

                <div class="wd-text-input">

                              <b-form-select class="wd-edited" v-model="editSchedule.end_time" value-field="value"
      text-field="label"  label="label"
                              :options="time_options"
                              placeholder="Select time"
                              :debounce="250"></b-form-select>
                </div>
                </div>
                <div class="col-md-12" >
                  <div class="date-check mb-2 mt-2"  >
                        <b-form-checkbox
                          id="checkbox-group-1"
                          v-model="editSchedule.all_day"
                          :value="1"
                          name="flavour-1"
                        >All day</b-form-checkbox>
                      </div>
                </div>
                <div class="col-md-12">
                <label for="jobInfoName">Repeat</label>
                <div class="wd-v-select">

                              <b-form-select class="wd-edited" v-model="editSchedule.repeat"  label="name"
                              :options="[{text : 'No', value :'No'},{text :'Yes', value : 'Yes'}]"
                              placeholder="Select calendar"
                              :debounce="250"></b-form-select>
                            </div>
                </div>
                <div class="col-md-12" v-if="editSchedule.repeat == 'Yes'">
                  <div class="date-check" style="margin:0 ;" >
                  <b-form-group >
                        <b-form-checkbox-group
                          id="checkbox-group-1"
                          v-model="editSchedule.repeat_details"
                          :options="options"
                          name="flavour-1"
                        ></b-form-checkbox-group>
                      </b-form-group>
                      </div>
                </div>
                <div class="col-md-12" v-if="editSchedule.repeat == 'Yes'">
                  <label for="jobInfoName">Repeat End Date</label>
                </div>
                <div class="col-md-12" v-if="editSchedule.repeat == 'Yes'">
                <div class="wd-text-input">
                  <date-picker :not-before="new Date()"   style="z-index: 10;" v-model="editSchedule.repeat_end_date" id="followUpDeadline" format="YYYY-MM-DD"
                                lang="en"></date-picker>
                            </div>
                </div>
                <div class="col-md-12 mt-2 mb-2">
                  <button @click="removeScheduleFun" type="submit" class="btn btn-danger float-right ml-2" :disabled='isDisabled' >Remove</button>
            <button  type="button" class="btn wd-button-primary float-right" v-if="isDisabled" :disabled='true' ><i style="margin-left: -4px;margin-right: 6px;" class="fa fa-spinner fa-spin"></i>Submit</button>
            <button v-if="!isDisabled" @click="editScheduleFun" type="submit" class="btn btn-save float-right" :disabled='isDisabled' >Submit</button>
                </div>
              </div>
            </div>

          </div>
          </b-modal>
    </div>
  </template>

  <script>
    import Vue from 'vue';
    import moment from 'moment'
  //   import * as mobiscroll from '@mobiscroll/javascript';
  // import '@mobiscroll/javascript/dist/css/mobiscroll.min.css';
//   import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
//   import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
  import DatePicker from 'vue2-datepicker'
  import CommonConstants from '@/constants/constants.js'
  import Multiselect from 'vue-multiselect'

    export default {

      components :{DatePicker, 'vue-multiselect': Multiselect},
      props: ['calendar_options','calendar_options_blackout'],
      data() {
        return {
            isDisabled : false,
            constants: CommonConstants,
            calendarCheckAllBlackout: 1,
            calendarCheckBlackout : [],
            calendarCheck : [],
            calendar : '',
            tempEvent : {},
            blackoutOptionOld : [],
            calendarCheckAll : 1,
            selected_job: '',
            jobs: [],
            calendarData : [],
            minDate : moment().format('YYYY-MM-DD'),
            successToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'success-toast'
              },
              errorToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'error-toast'
              },
            options: [
            {text :'S',value : 0},{text :'M',value :1},{text :'T',value :2},{text :'W',value :3},{text :'T',value :4},{text :'F',value :5},{text :'S',value : 6}
              ],
            schedule : {
                job_id : '',
                name : '',
                start_date : moment().format('YYYY-MM-DD'),
                start_time :  "0:0" ,
                end_time :  "0:0" ,
                repeat_end_date : '',
                calendar_id : '',
                repeat :'No',
                all_day : 0,
                repeat_details : [0,1,2,3,4,5,6]
            },
            editSchedule : {
                id : '',
                job_id : '',
                name : '',
                start_date : moment().format('YYYY-MM-DD'),
                start_time : { "label": "12:00 AM", "value": "0:0" },
                end_time : { "label": "12:00 AM", "value": "0:0" },
                repeat_end_date : '',
                calendar_id : '',
                repeat :'No',
                all_day : 0,
                repeat_details : [ 0,1,2,3,4,5,6]
            },
            time_options : [
              { "label": "12:00 AM", "value": "0:0" },
              { "label": "12:30 AM", "value": "0:30" },
              { "label": "01:00 AM", "value": "1:0" },
              { "label": "01:30 AM", "value": "1:30" },
              { "label": "02:00 AM", "value": "2:0" },
              { "label": "02:30 AM", "value": "2:30" },
              { "label": "03:00 AM", "value": "3:0" },
              { "label": "03:30 AM", "value": "3:30" },
              { "label": "04:00 AM", "value": "4:0" },
              { "label": "04:30 AM", "value": "4:30" },
              { "label": "05:00 AM", "value": "5:0" },
              { "label": "05:30 AM", "value": "5:30" },
              { "label": "06:00 AM", "value": "6:0" },
              { "label": "06:30 AM", "value": "6:30" },
              { "label": "07:00 AM", "value": "7:0" },
              { "label": "07:30 AM", "value": "7:30" },
              { "label": "08:00 AM", "value": "8:0" },
              { "label": "08:30 AM", "value": "8:30" },
              { "label": "09:00 AM", "value": "9:0" },
              { "label": "09:30 AM", "value": "9:30" },
              { "label": "10:00 AM", "value": "10:0" },
              { "label": "10:30 AM", "value": "10:30" },
              { "label": "11:00 AM", "value": "11:0" },
              { "label": "11:30 AM", "value": "11:30" },
              { "label": "12:00 PM", "value": "12:0" },
              { "label": "12:30 PM", "value": "12:30" },
              { "label": "01:00 PM", "value": "13:0" },
              { "label": "01:30 PM", "value": "13:30" },
              { "label": "02:00 PM", "value": "14:0" },
              { "label": "02:30 PM", "value": "14:30" },
              { "label": "03:00 PM", "value": "15:0" },
              { "label": "03:30 PM", "value": "15:30" },
              { "label": "04:00 PM", "value": "16:0" },
              { "label": "04:30 PM", "value": "16:30" },
              { "label": "05:00 PM", "value": "17:0" },
              { "label": "05:30 PM", "value": "17:30" },
              { "label": "06:00 PM", "value": "18:0" },
              { "label": "06:30 PM", "value": "18:30" },
              { "label": "07:00 PM", "value": "19:0" },
              { "label": "07:30 PM", "value": "19:30" },
              { "label": "08:00 PM", "value": "20:0" },
              { "label": "08:30 PM", "value": "20:30" },
              { "label": "09:00 PM", "value": "21:0" },
              { "label": "09:30 PM", "value": "21:30" },
              { "label": "10:00 PM", "value": "22:0" },
              { "label": "10:30 PM", "value": "22:30" },
              { "label": "11:00 PM", "value": "23:0" },
              { "label": "11:30 PM", "value": "23:30" }
            ],
            colors : [
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            "3b83c0", "FA8072", "0E743F",
            "7FFF00", "ADFF2F", "FF0000", "00FF7F", "00FF7F",
            "ADD8E6", "6B8E23", "9ACD32", "32CD32", "00FF00",
            ],
            calendars : []
        }
      },

      watch: {
        calendarCheckAll(newVal, oldVal){
          if(newVal == 1){
            this.calendarCheck = []
            this.calendar_options.forEach(val => {
              this.calendarCheck.push(val.id)
            })
          }else{
            this.calendarCheck = []
          }
        },
        calendarCheckAllBlackout(newVal, oldVal){
          if(newVal == 1){
            this.calendarCheckBlackout = []
            this.calendar_options_blackout.forEach(val => {
              this.calendarCheckBlackout.push(val.type)
            })
          }else{
            this.calendarCheckBlackout = []
          }
        },
        calendarCheck(newVal){
          let self  = this;
          var evs = [];
          console.log(self.calendarDataGeneral.length)
          for (var i = 0; i < self.calendarDataGeneral.length; ++i) {
                        var item = self.calendarDataGeneral[i];
                        if (item.type && self.calendarCheckBlackout.indexOf(item.type) > -1) {
                          let flag = 0
                          console.log(item);
                            evs.push(item);

                        }
                    }
                    for (var i = 0; i < self.calendarDataGeneral.length; ++i) {
                        var item = self.calendarDataGeneral[i];
                        if (item.resource && newVal.indexOf(item.resource) > -1) {
                            evs.push(item);
                        }
                    }

                this.calendar.setEvents(evs);
        },
        calendarCheckBlackout(newVal){
          let self = this;
          var evs = [];
          console.log('ss',this.calendarDataGeneral);
          for (var i = 0; i < this.calendarDataGeneral.length; ++i) {
                        var item = this.calendarDataGeneral[i];
                        if (item.resource && self.calendarCheck.indexOf(item.resource) > -1) {
                            evs.push(item);
                        }
                    }
                    for (var i = 0; i < this.calendarDataGeneral.length; ++i) {
                        var item = this.calendarDataGeneral[i];
                        if (item.type && newVal.indexOf(item.type) > -1) {
                          let flag = 0

                            evs.push(item);

                        }
                    }
                    console.log(evs.length);
                // this.calendarData = evs;
                this.calendar.setEvents(evs);
        },
        'selected_job': {
            handler: function (after, before) {
                if(after){
                  this.schedule.name = after.description+' - '+after.title
                  this.schedule.job_id = after.job_id
                }
            },
            deep: true
        }
      },

      created() {

      },
      mounted() {
        let self = this;
        //self.getAllCalendar();
        this.getBlackoutOptionData()
        self.calendar_options.forEach(val => {
          self.calendarCheck.push(val.id)
        })
        console.log('suman',self.calendar_options_blackout);
        self.calendar_options_blackout.forEach(val => {
          if(val.name == 'Jobs')
           val.type = "Job"
          if(val.name == 'People')
           val.type = "Employee"
          if(val.name == 'Assets')
           val.type = "Assets"
          self.calendarCheckBlackout.push(val.type)
        })
        var timer;
        var $searchInput;

        var list = mobiscroll.eventcalendar('#demo-search-list', {
              view: {
                  agenda: {
                      type: 'year',
                      size: 5
                  }
              },
              showControls: false,
              onEventClick: function (args) {
                self.calendar.navigate(args.event.start);
                self.calendar.setSelectedEvents([args.event]);
                  popup.close();
              }
          });
          const styleTag = document.createElement("style");
          document.head.appendChild(styleTag);

          // Generate and add the CSS rules to the <style> tag
          let css = '';
          this.calendar_options.forEach((color, index) => {
            const className = `.check-cal-${color.id}`;
            const colorValue = color.color ? color.color : '#2196f3';
            // Apply 0.3 opacity to the color for both fill and border
            css += `
              ${className}:before {
                color: ${colorValue}!important;
                box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 32px 0 20px, -5px 5px 0 10px, 20px -12px 0 11px;
                animation: b 0.3s forwards;
              }
              ${className} {
                color: ${colorValue}!important;
                border-color: ${colorValue}!important;
                opacity: 0.5;
              }
              /* Ensure the checkmark is white and fully visible */
              .wd-checkbox label input[type=checkbox]:checked + .checkbox-decorator ${className}:before {
                color: ${colorValue}!important;
                opacity: 1;
              }
            `;
        });
        this.calendar_options_blackout.forEach((color, index) => {
            const className = `.check-blackout-${color.name}`;
            const colorValue = color.color ? color.color : '#2196f3';
            // Apply 0.3 opacity to the color for both fill and border
            css += `
              ${className}:before {
                color: ${colorValue}!important;
                box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 32px 0 20px, -5px 5px 0 10px, 20px -12px 0 11px;
                animation: b 0.3s forwards;
              }
              ${className} {
                color: ${colorValue}!important;
                border-color: ${colorValue}!important;
                opacity: 0.5;
              }
              /* Ensure the checkmark is white and fully visible */
              .wd-checkbox label input[type=checkbox]:checked + .checkbox-decorator ${className}:before {
                color: ${colorValue}!important;
                opacity: 1;
              }
            `;
        });
          styleTag.innerHTML = css;
        mobiscroll.setOptions({
                theme: 'ios',
                themeVariant: 'light',
                clickToCreate: false,
                dragToCreate: false,
                dragToMove: false,
                dragToResize: false,
                eventDelete: false
            });
            var today = new Date();
            var currentDate = new Date(),
                view = 'calendar';


        self.calendar = mobiscroll.eventcalendar('#eventcalendar', {
           // resources: self.calendar_options,
            view: {
                calendar: { type: 'month',popover: true, labels: 6  }
            },

          //   invalid: [{
          //     recurring: {
          //         repeat: 'daily',
          //         until: today.setDate(today.getDate() - 1)
          //     }
          // }],
          renderHeader: function () {
            // return '<div mbsc-calendar-nav class="md-custom-header-nav"></div>' +
            //     '<div class="md-custom-header-controls">' +
            //     '<div mbsc-calendar-prev class="cal-header-prev" data-icon="material-arrow-back"></div>' +
            //     '<div mbsc-calendar-next class="cal-header-next"></div>' +
            //     '</div>' +

            //     '<div class="md-custom-header-view">' +
            //         '<label>Y<input  mbsc-segmented type="radio" name="view" value="year" class="md-view-change"></label>'
            //         +
            //     '<label>M<input " mbsc-segmented type="radio" name="view" value="calendar" class="md-view-change" checked ></label>' +
            //     '<label>W<input  mbsc-segmented type="radio" name="view" value="schedule" class="md-view-change" ></label>' +
            //     '<label>D<input  mbsc-segmented type="radio" name="view" value="day" class="md-view-change"></label>'
            //     +
            //     '<label>A<input  mbsc-segmented type="radio" name="view" value="agenda" class="md-view-change"></label>'
            //     +
            //     '</div>';
            return '<div class="row"><div class="col-12"><div mbsc-calendar-nav class="md-custom-header-nav"></div></div>' +
                '<div class="col-12" ><div class="md-custom-header-controls mbsc-flex-1-0" style="display:flex;justify-content:center;">' +
                '<div mbsc-calendar-prev class="cal-header-prev" data-icon="material-arrow-back"></div>' +
                '<div mbsc-calendar-today class="md-custom-header-today"></div>' +
                '<div mbsc-calendar-next class="cal-header-next"></div>' +
                '</div></div>' +
                '<div class="col-12" style="display:contents;"><div class="md-seach-header-bar mbsc-flex-1-0">' +
            '<label><input id="md-search-demo-input" mbsc-input data-start-icon="material-search" data-input-style="box" placeholder="Search events"></input></label>' +
            '</div></div>' +
                '<div class="col-12" style="display:contents;"><div class="md-custom-header-view mbsc-flex-1-0">' +
                    '<label>Year<input  mbsc-segmented type="radio" name="view" value="year" class="md-view-change"></label>'
                    +
                '<label>Month<input " mbsc-segmented type="radio" name="view" value="calendar" class="md-view-change" checked></label>' +
                '<label>Week<input  mbsc-segmented type="radio" name="view" value="schedule" class="md-view-change"></label>' +
                '<label>Day<input  mbsc-segmented type="radio" name="view" value="day" class="md-view-change"></label>'
                +
                '<label>Agenda<input  mbsc-segmented type="radio" name="view" value="agenda" class="md-view-change"></label>'
                +
                '</div></div></div>';
          },
          onEventClick: function (event, inst) {

              console.log(event);
                // if (event.date < today){
                //     inst.updateEvent(event);
                //     mobiscroll.toast({
                //         message: 'Can\'t edit past event'
                //     });
                //     return false;
                // }
            self.editSchedule.id = event.event.id;
            self.editSchedule.calendar_id = event.event.calendar_id;
            self.editSchedule.name = event.event.name;
            self.editSchedule.repeat = event.event.repeat == 1 ? 'Yes' : 'No';
            self.editSchedule.start_date = moment(event.event.start);
            self.editSchedule.job_id = event.event.job_id
            self.editSchedule.parent_id = event.event.parent_id
            self.editSchedule.all_day = event.event.all_day
            self.time_options.forEach(element => {
              if(element.label.toString() == moment(event.event.start).format('hh:mm A').toString()){
                self.editSchedule.start_time = element.value;
              }
            });
            self.time_options.forEach(element => {
              if(element.label == moment(event.event.end).format('hh:mm A'))
                self.editSchedule.end_time = element.value;
            });
            if(event.event.repeat_flag == 1){
              self.editSchedule.repeat = 'Yes';
              console.log(JSON.parse(event.event.repeat_details));
              self.editSchedule.repeat_details = JSON.parse(event.event.repeat_details).repeat_details
              self.editSchedule.repeat_end_date = moment(JSON.parse(event.event.repeat_details).repeat_end_date)
            }
            if(event.event.type == 'Asset' || event.event.type == 'Job' || event.event.type == 'Employee'){

            }else
              self.$refs['obeModal'].show();

          },
          onEventCreated: function (args) {
            // popup.close();

            // store temporary event
            self.tempEvent = args.event;
            self.openobModal();
        },
          onPageLoading: function (event, ins) {


              // mobiscroll.util.http.getJson('https://trial.mobiscroll.com/filter-resource-events/', function (data) {
              //   ins.setEvents(data);

              //     mobiscroll.toast({
              //         message: 'New events loaded'
              //     });
              // }, 'jsonp');
            }


      });
      var searchInput = document.getElementById('md-search-demo-input');

      var popup = mobiscroll.popup('#demo-search-popup', {
          display: 'anchored',
          showArrow: false,
          showOverlay: false,
          scrollLock: false,
          contentPadding: false,
          focusOnOpen: false,
          focusOnClose: false,
          focusElm: searchInput,
          anchor: searchInput
      });

      searchInput.addEventListener('input', function (ev) {
          var text = ev.target.value;
          clearTimeout(timer);
          timer = setTimeout(function () {
              if (text.length > 0) {
                  // mobiscroll.util.http.getJson('https://trial.mobiscroll.com/searchevents/?text=' + text, function (data) {

                  // }, 'jsonp');
                  let filter_list =  [];
                  self.calendarData.forEach(val => {
                    if((val.name && val.name.includes(text)) || (val.title && val.title.includes(text))){
                      filter_list.push(val)
                    }
                  })
                  list.setEvents(filter_list);
                  popup.open();
              } else {
                  popup.close();
              }
          }, 200);
      });


      searchInput.addEventListener('focus', function (ev) {
          if (ev.target.value.length > 0) {
              popup.open();
          }
      });
      function getFirstDayOfWeek(d, prev) {
            var day = d.getDay(),
                diff = d.getDate() - day + (prev ? -7 : 7);
            return new Date(d.setDate(diff));
        }

        function navigatePage(prev) {
            if (view == 'calendar') {
                var prevNextPage = new Date(currentDate.getFullYear(), currentDate.getMonth() + (prev ? -1 : 1), 1);
                self.calendar.navigate(prevNextPage);
                currentDate = prevNextPage;
            }else if(view == 'day' || view == 'agenda'){
              var prevNextPage = new Date(currentDate.getFullYear(), currentDate.getMonth(),currentDate.getDate()  + (prev ? -1 : 1), 1);
                self.calendar.navigate(prevNextPage);
                currentDate = prevNextPage;
            }else if(view == 'week'){
              var prevNextPage = new Date(currentDate.getFullYear(), currentDate.getMonth(),currentDate.getDate()  + (prev ? -7 : 7), 1);
                self.calendar.navigate(prevNextPage);
                currentDate = prevNextPage;
            } else {
                var prevNextSunday = getFirstDayOfWeek(currentDate, prev);
                self.calendar.navigate(prevNextSunday);
                currentDate = prevNextSunday;
            }
        }

        document.querySelectorAll('.md-view-change').forEach(function (elm) {
            elm.addEventListener('change', function (ev) {
                switch (ev.target.value) {
                    case 'calendar':
                    self.calendar.setOptions({
                            view: {
                              calendar: { type: 'month',popover: true,labels: 6  }
                            }
                        });
                        view = 'calendar';
                        break;
                    case 'schedule':
                    self.calendar.setOptions({
                            view: {
                              calendar: { type: 'week',popover: true, },
                              schedule: { type: 'week' }
                            }
                        });
                        view = 'week';
                        break;
                    case 'year':
                    self.calendar.setOptions({
                            view: {
                                calendar: { type: 'year',popover: true, },
                                agenda: { type: 'year' }
                            }
                        });
                        view = 'year';
                        break;
                    case 'day':
                    self.calendar.setOptions({
                            view: {
                              schedule: { type: 'day' }
                            }
                        });
                        view = 'day';
                        break;
                    case 'agenda':
                    self.calendar.setOptions({
                            view: {
                              calendar: { type: 'week' },
                              agenda: { type: 'day' }
                            }
                        });
                        view = 'day';
                        break;
                }
            });
        });

        // document
        //     .getElementById('nav-to-prev-page')
        //     .addEventListener('click', function () {
        //         navigatePage(true);
        //     });

        // document
        //     .getElementById('nav-to-next-page')
        //     .addEventListener('click', function () {
        //         navigatePage(false);
        //     });
        self.getScheduleEvents(1);
      },
      computed: {

      },

      methods: {
        jobSearch: _.debounce(function (d) {
        let self = this
        this.isLoading = true
        self.jobs = []
        if (d) {
          axios.get(this.constants.api_url + 'jobs-input-ajax/' + d,  {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
              }
            })
            .then(function (res) {
              self.jobs = res.data.data
              self.isLoading = true
            })
        }
      }, 600),

      getScheduleEvents(flag = 0){
          let self = this;
          self.calendarData = [];
          axios.post(self.constants.api_url + 'job/schedule/get/all', {}, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
              }
            })
            .then(function (response) {
                self.calendarData = []
                self.calendarDataGeneral = []
                if (response.data.flag) {
                  response.data.data.forEach(value => {
                    self.calendar_options.forEach(element => {
                      if(element.id == value.resource)
                        value.color = element.color
                    });
                    if (self.calendarCheck.indexOf(value.resource) > -1)
                      self.calendarData.push(value);
                    self.calendarDataGeneral.push(value);
                  })
                  self.calendar.setEvents(self.calendarData);

                }
                  self.getBlackoutScheduleEvents(1);
              })
        },
        getBlackoutScheduleEvents(flag = 0){
          let self = this;
          self.blackoutCalendarData = []
          axios.post(self.constants.api_url + 'job/blackout-schedule/get/All', {}, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
              }
            })
            .then(function (response) {
                if (response.data.flag) {
                  if(flag == 0){
                  response.data.data.forEach(value => {
                    self.calendar_options_blackout.forEach(element => {
                      if(element.type == value.type)
                        value.color = element.color
                    });
                    // self.blackoutCalendarData.push(value);
                    if (self.calendarCheckBlackout.indexOf(value.resource) > -1)
                      self.blackoutCalendarData.push(value);
                    self.calendarDataGeneral.push(value);

                  })
                  }
                  if(flag == 1){
                      var evs = self.calendarData;
                        self.calendarDataGeneral.forEach((element,key) => {

                        if(element.type == 'Asset' || element.type == 'Job' || element.type == 'Employee') {
                                  self.calendarDataGeneral.splice(key)
                                  evs.splice(key)
                        }

                        });
                        for (var i = 0; i < response.data.data.length; ++i) {
                          var item = response.data.data[i];
                          self.calendar_options_blackout.forEach(element => {
                            if(element.type == item.type)
                            item.color = element.color
                          });

                            if (self.calendarCheckBlackout.indexOf(item.type) > -1) {
                                evs.push(item);

                            }

                            self.calendarDataGeneral.push(item)
                        }
                        self.calendar.setEvents(evs);
                    }
                  // self.calendar.setEvents(response.data.data);

                }
              })
        },
        getBlackoutOptionData: function () {
          let self = this
          axios.get(self.constants.api_url + 'get-blackout-options', {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
              }
            })
            .then(function (response) {
              let temp = response.data.data;
              console.log(temp);
              self.blackoutOptionOld = temp;

            })
        },
        disabledBeforeToday(date){alert()
          return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
        closeobModal(){
            this.$refs['obModal'].hide();
            this.calendar.removeEvent(this.tempEvent);
            this.selected_job = '';
            this.schedule.name = '';
        },
        openobModal(){
            this.$refs['obModal'].show();
        },
        closeobeModal(){
            this.$refs['obeModal'].hide();
            this.calendar.removeEvent(this.tempEvent);
        },
        openobeModal(){
          this.$refs['obeModal'].show();
        },
        createSchedule(){

          let self = this;
          console.log(moment(this.schedule.end_time, 'H:mm'));
          if (this.schedule.name === '' ) {
            Vue.$toast.error('Name is required')
          } else if (this.schedule.calendar_id === '' ) {
            Vue.$toast.error('Calendar is required')
          }else if (this.schedule.start_date === '' ) {
            Vue.$toast.error('Date is required')
          }else if (this.schedule.start_time === '' ) {
            Vue.$toast.error('Time is required')
          }else if (this.schedule.end_time === '' ) {
            Vue.$toast.error('Time is required')
          }else if (this.schedule.all_day == 0 && !moment(this.schedule.end_time, 'H:mm').isAfter(moment(this.schedule.start_time, 'H:mm')) ) {
            Vue.$toast.error('End Time should be greater')
          }else if (this.schedule.repeat === 'Yes' && !this.schedule.repeat_end_date ) {
            Vue.$toast.error('Repeat end date is required')
          }else{
            self.schedule.start_date = moment(this.schedule.start_date).format('YYYY-MM-DD')
            self.schedule.repeat_end_date = moment(this.schedule.repeat_end_date).format('YYYY-MM-DD')
            if(this.schedule.repeat === 'Yes'){
              self.schedule.repeat_dates = self.getDatesBetween(self.schedule.start_date, self.schedule.repeat_end_date, self.schedule.repeat_details)
            }
            self.isDisabled = true
          axios.post(self.constants.api_url + 'job/schedule/create', self.schedule, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
          }
        })
          .then(function (response) {
            if (response.data.flag) {
              self.schedule = {
                    job_id : '',
                    name : '',
                    start_date : moment().format('YYYY-MM-DD'),
                    start_time :  "0:0",
                    end_time :  "0:0" ,
                    repeat_end_date : '',
                    calendar_id : '',
                    repeat :'No',
                    all_day : 0,
                    repeat_details : [ 0,1,2,3,4,5,6]
                };
              self.closeobModal()
              self.isDisabled = false;
              self.getScheduleEvents()

            }else{
              self.isDisabled = false;
              Vue.$toast.error(response.data.message)
            }
          })
          .catch(function (error) {
            self.isDisabled = false;
            self.$toasted.show(error, self.errorToast)
          })
        }
        },
        editScheduleFun(){

          let self = this;
          if (this.editSchedule.name === '' ) {
            Vue.$toast.error('Name is required')
          } else if (this.editSchedule.calendar_id === '' ) {
            Vue.$toast.error('Calendar is required')
          }else if (this.editSchedule.start_date === '' ) {
            Vue.$toast.error('Date is required')
          }else if (this.editSchedule.start_time === '' ) {
            Vue.$toast.error('Time is required')
          }else if (this.editSchedule.end_time === '' ) {
            Vue.$toast.error('Time is required')
          }else if (this.editSchedule.all_day == 0 && !moment(this.editSchedule.end_time, 'H:mm').isAfter(moment(this.editSchedule.start_time, 'H:mm'))) {
            Vue.$toast.error('End Time should be greater')
          }else if (this.editSchedule.repeat === 'Yes' && !this.editSchedule.repeat_end_date ) {
            Vue.$toast.error('Repeat end date is required')
          }else{
            self.editSchedule.start_date = moment(this.editSchedule.start_date).format('YYYY-MM-DD')
            self.editSchedule.repeat_end_date = moment(this.editSchedule.repeat_end_date).format('YYYY-MM-DD')
            self.isDisabled = true
            if(this.editSchedule.repeat === 'Yes'){
              self.editSchedule.repeat_dates = self.getDatesBetween(self.editSchedule.start_date, self.editSchedule.repeat_end_date, self.editSchedule.repeat_details)
            }
          axios.post(self.constants.api_url + 'job/schedule/edit', self.editSchedule, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
          }
          })
          .then(function (response) {
            if (response.data.flag) {
              self.editSchedule = {
                    job_id : '',
                    name : '',
                    start_date : moment().format('YYYY-MM-DD'),
                    start_time : { "label": "12:00 AM", "value": "0:0" },
                    end_time : { "label": "12:00 AM", "value": "0:0" },
                    repeat_end_date : '',
                    calendar_id : '',
                    repeat :'No',
                    all_day : 0,
                    repeat_details : [ 0,1,2,3,4,5,6]
                };
              self.closeobeModal()
              self.isDisabled = false;
              self.getScheduleEvents()

            }
          })
          .catch(function (error) {
            self.isDisabled = false;
            self.$toasted.show(error, self.errorToast)
          })
          }
          },
          getDatesBetween(startDate, endDate, weekdays) {
            const dates = [];
            let date = '';
            const currentDate = moment(startDate);
            const endDateM = moment(endDate);

            while (currentDate <= endDateM) {
              if (weekdays.includes(currentDate.day())) {
                date = moment(currentDate);
                dates.push(date.format('YYYY-MM-DD'));
              }
              currentDate.add(1, 'day');
            }

            return dates;
          },
          removeScheduleFun(){

              let self = this;
              if(confirm("Are you sure you want to remove?")){
              self.isDisabled = true
              axios.get(self.constants.api_url + 'job/schedule/remove/'+self.editSchedule.id, {
              headers: {
                'Content-type': "application/json",
                'token': localStorage.getItem('token')
              }
              })
              .then(function (response) {
                if (response.data.flag) {
                  self.editSchedule = {
                        job_id : '',
                        name : '',
                        start_date : moment().format('YYYY-MM-DD'),
                        start_time : { "label": "12:00 AM", "value": "0:0" },
                        end_time : { "label": "12:00 AM", "value": "0:0" },
                        repeat_end_date : '',
                        calendar_id : '',
                        repeat :'No',
                        all_day : 0,
                        repeat_details : [ 'Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
                    };
                  self.closeobeModal()
                  self.isDisabled = false;
                  self.getScheduleEvents()

                }
              })
              .catch(function (error) {
                self.isDisabled = false;
                self.$toasted.show(error, self.errorToast)
              })
          }
        },
        filterEvents(events, selected) {
                var evs = [];
                    for (var i = 0; i < events.length; ++i) {
                        var item = events[i];
                        if (selected.indexOf(item.resource) > -1) {
                            evs.push(item);
                        }
                    }
                console.log(evs);
                this.calendar.setEvents(evs);
            }
      }
    }
  </script>

  <style >
    .wd-checkbox label, label.checkbox-inline {
	 position: relative;
	 padding-left: 28px;
	 font-size: 14px;
	 cursor: pointer;
	 margin: 8px 0;
}
 .wd-checkbox label .checkbox-decorator, label.checkbox-inline .checkbox-decorator {
	 position: absolute;
	 left: 0;
	 padding: 11px 10px 8px;
	 margin: -10px;
	 line-height: 10px;
	 vertical-align: middle;
	 cursor: pointer;
	 border-radius: 100%;
}
 .wd-checkbox label .checkbox-decorator .check, label.checkbox-inline .checkbox-decorator .check {
	 position: relative;
	 z-index: 1;
	 display: inline-block;
	 width: 20px;
	 height: 20px;
	 overflow: hidden;
	 border: 2px solid rgba(0, 0, 0, .54);
	 border-radius: 0.125rem;
}
 .wd-checkbox label .checkbox-decorator .check:before, label.checkbox-inline .checkbox-decorator .check:before {
	 position: absolute;
	 display: block;
	 width: 0;
	 height: 0;
	 margin-top: -4px;
	 margin-left: 6px;
	 color: #757575;
	 content: "";
	 box-shadow: 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, inset 0 0 0 0;
	 transform: rotate(45deg)!important;
	 animation: c;
}
 .is-focused .wd-checkbox label .checkbox-decorator .check:before, .is-focused label.checkbox-inline .checkbox-decorator .check:before {
	 animation: c 0.3s forwards;
}
 .wd-checkbox label input[type=checkbox], label.checkbox-inline input[type=checkbox] {
	 position: absolute;
	 left: 0;
	 z-index: -1;
	 width: 0;
	 height: 0;
	 margin: 0;
	 overflow: hidden;
	 pointer-events: none;
	 opacity: 0;
}
 .wd-checkbox label input[type=checkbox]:focus + .checkbox-decorator .check:after, label.checkbox-inline input[type=checkbox]:focus + .checkbox-decorator .check:after {
	 opacity: 0.2;
}
 .wd-checkbox label input[type=checkbox]:checked + .checkbox-decorator .check, label.checkbox-inline input[type=checkbox]:checked + .checkbox-decorator .check {
	 color: blue;
	 border-color: blue;
}
 .wd-checkbox label input[type=checkbox]:checked + .checkbox-decorator .check:before, label.checkbox-inline input[type=checkbox]:checked + .checkbox-decorator .check:before {
	 color: blue;
	 box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 0 32px 0 20px, -5px 5px 0 10px, 20px -12px 0 11px;
	 animation: b 0.3s forwards;
}
 .wd-checkbox label input[type=checkbox][disabled] + .checkbox-decorator .check:after, .wd-checkbox label input[type=checkbox][disabled] .check:after, fieldset[disabled] .wd-checkbox label input[type=checkbox] + .checkbox-decorator .check:after, fieldset[disabled] .wd-checkbox label input[type=checkbox] .check:after, fieldset[disabled] label.checkbox-inline input[type=checkbox] + .checkbox-decorator .check:after, fieldset[disabled] label.checkbox-inline input[type=checkbox] .check:after, label.checkbox-inline input[type=checkbox][disabled] + .checkbox-decorator .check:after, label.checkbox-inline input[type=checkbox][disabled] .check:after {
	 background-color: rgba(0, 0, 0, .87);
	 transform: rotate(-45deg);
}
 .wd-checkbox label input[type=checkbox][disabled] + .checkbox-decorator .check, .wd-checkbox label input[type=checkbox][disabled] .check, fieldset[disabled] .wd-checkbox label input[type=checkbox] + .checkbox-decorator .check, fieldset[disabled] .wd-checkbox label input[type=checkbox] .check, fieldset[disabled] label.checkbox-inline input[type=checkbox] + .checkbox-decorator .check, fieldset[disabled] label.checkbox-inline input[type=checkbox] .check, label.checkbox-inline input[type=checkbox][disabled] + .checkbox-decorator .check, label.checkbox-inline input[type=checkbox][disabled] .check {
	 border-color: rgba(0, 0, 0, .26);
}
 .wd-checkbox label input[type=checkbox][disabled] + .checkbox-decorator .ripple-container, fieldset[disabled] .wd-checkbox label input[type=checkbox] + .checkbox-decorator .ripple-container, fieldset[disabled] label.checkbox-inline input[type=checkbox] + .checkbox-decorator .ripple-container, label.checkbox-inline input[type=checkbox][disabled] + .checkbox-decorator .ripple-container {
	 display: none;
}


</style>